import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BaseComponent } from '~app/app/~shared/abstract-components/base.component';
import { getTimeBandFromDate } from '~app/app/~shared/utils/utils';

@Component({
  selector: 'subscriber-ads-datatable',
  standalone: false,
  templateUrl: './subscriber-ads-datatable.component.html',
  styleUrl: './subscriber-ads-datatable.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubscriberAdsDatatableComponent extends BaseComponent {
  getTimeBandFromDate = getTimeBandFromDate;

  subscribers = input([]);

  displayedColumns: string[] = [
    'brand',
    'date',
    'mediaType',
    'channel',
    'location',
    'timeSlot',
    'price'
  ];
}
